import React, { createContext, useState, useContext } from "react";
import { GetBridge } from "../../services/backendServices";
import toast from "react-hot-toast";
// Create a context for BridgeData
export const BridgeContext = createContext();
/*** BridgeContextProvider: A provider component to manage and supply bridge and trigger data*/
export const BridgeContextProvider = ({ children }) => {
    const [isBridgeDataLoading, setIsBridgeDataLodaing] = useState(false);  // State to track loading status for user bridge data 
    const [isBridgeDataFetched, setIsBridgeDataFetched] = useState(false); // state to track user bridge data has been fetched
    const [bridgeData, setBridgeData] = useState([]); // state to store bridge data 
    // // Function to fetch usr bridge data 
    const fetchBridgedata = async () => {

        try {
            setIsBridgeDataLodaing(true); // Start loading
            const res = await GetBridge();

            if (res.status) {
                setBridgeData(res.data);
                setIsBridgeDataFetched(true); // Mark data as fetched
            }
        } catch (e) {
            console.error("Error fetching user bridge:", e);
        } finally {
            setIsBridgeDataLodaing(false); // End loading
        }
    };


    /**
   * Updates a specific bridge's full data by bridge ID.
   * @param {Object} updatedData - Updated bridge data
   */
    const updateBridgeData = (updatedData) => {
        setBridgeData((prevData) =>
            prevData.map((item) =>
                item.bridge_id === updatedData.bridge_id ? { ...item, ...updatedData } : item
            )
        );
    };

    /**
  * Updates specific fields of a bridge by bridge ID.
  * @param {number} bridge_id - ID of the bridge
  * @param {Object} updatedFields - Fields to update
  */
    const updateBridgeField = (bridge_id, updatedFields) => {
        setBridgeData((prevData) =>
            prevData.map((item) =>
                item.bridge_id === bridge_id ? { ...item, ...updatedFields } : item
            )
        );
    };

    /**
 * Removes a bridge by bridge ID.
 * @param {number} bridge_id - ID of the bridge to remove
 */
    const removeBridge = (bridge_id) => {
        setBridgeData((prevData) => prevData.filter((item) => item.bridge_id !== bridge_id));
    };


    /**
  * Adds a new bridge entry.
  * @param {Object} newData - New bridge data
  */
    const addBridge = (newData) => {
        const updatedData = { ...newData, open_positions_count: 0, today_signal_count: 0 };
        // Update the state with the new data
        setBridgeData(prevData => [...prevData, updatedData]);
    };

    // Function To handle refresh Bridge Data
    const handelRefreshBridgeData = async () => {
        try {
            await fetchBridgedata();
            toast.success("Data refreshed successfully!");
        } catch (error) {
            toast.error("Error refreshing data. Please try again.");
        }
    };
    //  Resets fetched status flags in the BridgeContext.
    const resetBridgeContext = () => {
        setIsBridgeDataFetched(false);
    };
    return (
        // The BridgeContext.Provider component provides state and functions to the children components
        <BridgeContext.Provider value={{
            bridgeData, // provides a user bridge data 
            setBridgeData, // Provides the function to set/update the user bridge data
            isBridgeDataLoading,  // Provides the loading state of user bridge data 
            fetchBridgedata, // provides a function for fetch user bridge data 
            isBridgeDataFetched, // provides the fetched status of user bridge data 
            setIsBridgeDataFetched, //Provides a function to manually update the fetched status of user bridge
            updateBridgeData, // provides the function to update bridge data 
            updateBridgeField, // provides a function to update the updated filled in bridge Data 
            removeBridge, // provides a function to remnove user bridge 
            addBridge,  // procide a function to add user bridge data 
            handelRefreshBridgeData, // provide the function to refresh user bridge data 
            resetBridgeContext
        }}>
            {children}
        </BridgeContext.Provider>
    );
};
// Custom hook to access BridgeContext data
export const useBridgeContext = () => {
    return useContext(BridgeContext);
};